/**
 * Paleta de las graficas del panel, sobre los tokens de grafico de Trazabis DS
 * (`--tz-chart-*` en `styles/tz-system.css`).
 *
 * Los valores se publican como custom properties de CSS y no como constantes
 * de JavaScript porque asi el cambio claro/oscuro lo resuelve el navegador,
 * sin escuchar `matchMedia` ni volver a renderizar. Recharts los acepta tal
 * cual: `fill` y `stroke` son propiedades de presentacion y admiten `var()`.
 */

/**
 * Trazabis DS: la serie unica es `--tz-chart-1` (Azul Trazabis en claro,
 * #9DBBF5 en oscuro). El lila (`--tz-chart-hi`) se reserva para un unico dato
 * destacado por grafica, y aqui no hay ninguno.
 */
export const SERIE = 'var(--tz-chart-1)'

/** Clase que ancla las variables; va en la raiz de cada grafica. */
export const CLASE_GRAFICA = 'viz-raiz'

/**
 * Roles, no colores. El componente se escribe contra estos nombres, de modo que
 * los dos temas se cambian en un unico sitio.
 */
export const TINTA = {
  superficie: 'var(--viz-superficie)',
  serie: 'var(--viz-serie)',
  primaria: 'var(--viz-tinta)',
  secundaria: 'var(--viz-tinta-2)',
  /** Ejes y etiquetas de eje: recesivos, pero por encima de 4.5:1. */
  apagada: 'var(--viz-tinta-apagada)',
  rejilla: 'var(--viz-rejilla)',
  eje: 'var(--viz-eje)',
  borde: 'var(--viz-borde)',
} as const

/**
 * Hoja local de la grafica. Se inyecta con un `<style>` junto a la grafica:
 * mantiene la paleta al lado de lo que pinta.
 *
 * Con Trazabis DS ya no hace falta declarar los dos temas: cada rol apunta a un
 * token `--tz-*`, y es `html.tz-dark` (que pone `src/tema/`) quien cambia sus
 * valores. Asi la grafica y la pagina no pueden discrepar, y al cambiar de tema
 * la grafica se repinta sola, sin escuchar nada ni volver a renderizar.
 */
export const CSS_PALETA = `
.${CLASE_GRAFICA} {
    --viz-superficie: var(--tz-surface);
    --viz-serie: ${SERIE};
    --viz-tinta: var(--tz-text);
    --viz-tinta-2: var(--tz-text-2);
    --viz-tinta-apagada: var(--tz-text-2);
    --viz-rejilla: var(--tz-chart-track);
    --viz-eje: var(--tz-border);
    --viz-borde: var(--tz-border);
}
`
